const exchangeRouter = [
    {
        path: 'list-exchange',
        name: 'exchange',
        component: () => import('@/views/admin/exchange/index.vue'),
        meta: {
            model: 'exchange',
            requiresAuth: true,
        }
    },
    {
        path: 'list-exchange/boxs',
        name: 'importExchangeBoxs',
        component: () => import('@/views/admin/exchange/box/index'),
        meta: {
            model: 'record_detail',
            requiresAuth: true,
        }
    },
    {
        path: 'list-exchange/view/:id',
        name: 'viewExchange',
        component: () => import("@/views/admin/exchange/function"),
        meta: {
            model: 'exchange',
            requiresAuth: true,
        }
    },
    {
        path: 'list-exchange/exchange',
        name: 'importExchange',
        component: () => import('@/views/admin/exchange/exchange/index'),
        meta: {
            model: 'record_detail',
            requiresAuth: true,
        }
    },
];

export default exchangeRouter;